var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CButton',{on:{"click":_vm.openAddress}},[_vm._v("获取用户地址信息")]),_c('CButton',{on:{"click":_vm.chooseInvoiceTitle}},[_vm._v("获取用户发票信息")]),_c('div',[_vm._v("--------------")]),_c('CButton',{on:{"click":_vm.chooseImage2}},[_vm._v("选择图片(2)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }